import type { ReactNode } from 'react';
import {
  FullScreenFrame as BaseFullScreenFrame,
  type FullScreenFrameProps,
} from '@asset-metrix/portal-ui';

import { usePortalTheme } from '../../app/usePortalTheme';

type Props = Omit<FullScreenFrameProps, 'showLogo'> & {
  children: ReactNode;
};

export const FullScreenFrame = ({ children, ...props }: Props) => {
  const { tenantThemeLoaded } = usePortalTheme();

  return (
    <BaseFullScreenFrame showLogo={tenantThemeLoaded} {...props}>
      {children}
    </BaseFullScreenFrame>
  );
};
